// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"eeb25c27","453":"30f05edc","744":"b6019e53","801":"0d8d5008"}[chunkId] + ".chunk.js";
};